import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { StaffingParagraph, StaffingRedText, StaffingText, StaffingTextContent } from "../../components/staffinghomepage/StaffingHomepage";
import { techStaffData } from "./data";
import {StaffingCard} from "./StaffingCard"
import { useParams } from "react-router-dom";
import { MiddleSectionContactUs as TechStaff } from "../ContactUsPage/middlesectioncontactus";
import { MiddleSectionContactUs as CallCenterStaff } from "../CallCenterPage/middlesectioncontactus";
import { MiddleSectionContactUs as FinanceStaff } from "../FinancePage/middlesectioncontactus";
import { MiddleSectionContactUs as HealthCompliance } from "../HealthCompliancePage/middlesectioncontactus";
import { BusinessInquiriesForm } from "../../components/form";
import { ContactUsDiv } from "../../components/staffinghomepage/StaffingHomepage";
import { ContactUsText } from "../../components/staffinghomepage/StaffingHomepage";
import { ContactUsButton } from "../../components/staffinghomepage/StaffingHomepage";

// icons 

import techicon from "../../images/staffingicons/techstaff.svg"
import financeicon from "../../images/staffingicons/financestaff.svg"
import healthicon from "../../images/staffingicons/healthcompliance.svg"
import callcentericon from "../../images/staffingicons/callcenter.svg"



const TechStaffingContainer = styled.div`
    margin-top: 90px;   
`;

const ImageGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 5%;
    margin-left: 10%;
    margin-right: 10%;

    @media screen and (max-width: 768px){
        grid-template-columns: repeat(2, 1fr)
    }
`;

const InfoContainer = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 5%;
    padding-left: 10%;
    padding-bottom: 5%;
    width: 100%;
    height: 100%;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 10px;
        background: linear-gradient(to top, transparent, rgba(0, 0, 0, 0.15));
        z-index: -1;
    }

    filter: drop-shadow(0px 10px 10px rgba(0, 0, 0, 0.15));
  
`;

const InfoWrapper = styled.div`
    display: flex; 
    flex-direction: row;
    align-items: center;
    width: 44%;
    border-bottom: 3px solid ${(props) => props.titleColor};

    @media screen and (max-width: 768px) {
        width: 85%;
        border-bottom: 2px solid ${(props) => props.titleColor};
    }
`;

const Icon = styled.img`
    width: 46px; 
    height: 46px;
`;

const InfoH2 = styled.h2`
    display: flex;
    width: 100%;
    font-family: Roboto;
    font-size: 40px;
    font-weight: 400;
    padding-left: 2%;

    @media screen and (max-width: 768px){
        font-size: 22px;
        width: 65%;
    }
`;

const InfoBold = styled.p`
    color: #282828;
    font-family: Sunflower;
    font-size: 20px;
    font-weight: 400;
    padding-top: 2%;

    @media screen and (max-width: 768px) {
        font-size: 13px;
    }
`;

const InfoText = styled.p`
    color: #282828;
    font-family: Sunflower;
    font-size: 22px;
    font-weight: 300;

    @media screen and (max-width: 768px) {
        font-size: 11px;
        width: 80%;
        text-align: left;
    }
`;


export function StaffingPages(){
    const [selectedItem, setSelectedItem] = useState(null);
    const { category } = useParams();

    const handleItemClick = (item) => {
        setSelectedItem(item)
    }

    useEffect(() => {
        const matchingItem = techStaffData.find(item => item.link === category);

        if (matchingItem) {
            setSelectedItem(matchingItem)
        }
    }, [category])


    const borderColors = ["#3588b1", "#499C99", "#883FBC", "#9D2222"]
    
    function getBorderColor(id){
        if (id >= 1 && id <= borderColors.length){
            return borderColors[id - 1];
        }
        return "none";
    }
    
    const backgroundColors = [
        "linear-gradient(180deg, rgba(167, 173, 176, 0.04) 0%, rgba(53, 136, 177, 0.09) 100%)",
        "linear-gradient(180deg, rgba(167, 173, 176, 0.04) 0%, rgba(73, 156, 153, 0.04) 0.01%, rgba(73, 156, 153, 0.09) 100%)",
        "linear-gradient(180deg, rgba(167, 173, 176, 0.04) 0%, rgba(136, 63, 188, 0.09) 100%)",
        "linear-gradient(180deg, rgba(167, 173, 176, 0.04) 0%, rgba(157, 34, 34, 0.09) 100%)"
    ]

    const titleColor = selectedItem ? getBorderColor(selectedItem.id) : "black"
    const backgroundColor = selectedItem ? backgroundColors[selectedItem.id - 1] : "none"

    const renderSelectedItemComponent = () => {
        if (selectedItem) {
            switch (selectedItem.id) {
                case 1:
                    return <TechStaff />;
                case 2:
                    return <FinanceStaff />;
                case 3:
                    return <CallCenterStaff />;
                case 4:
                    return <HealthCompliance />;
                default:
                    return null; 
            }
        }
        return null;
    }


    const formRef = useRef(null);
    const [isFormVisible, setIsFormVisible] = useState(false);

    const toggleFormVisibility = () => {
        setIsFormVisible(!isFormVisible)
    }

    useEffect(() => {
        const handleDocumentClick = (e) => {
          if (isFormVisible && formRef.current && !formRef.current.contains(e.target)) {
            toggleFormVisibility(); // Close the form if it's visible and the click is outside
          }
        };
    
        document.addEventListener('click', handleDocumentClick);
    
        return () => {
          document.removeEventListener('click', handleDocumentClick);
        };
    }, [isFormVisible]);

    // finance icons logic to be rendered

    function getIconForItem(itemId){
        switch(itemId){
            case 1:
                return techicon;
            case 2:
                return financeicon;
            case 3:
                return callcentericon;
            case 4:
                return healthicon;
            default: return null;
        }
    }

    return(
        <TechStaffingContainer id="tech-staffing-container" style={{ background: backgroundColor }}>
            <StaffingTextContent>
                <StaffingRedText>THE LABOR POOL IS <span style={{ fontWeight: "bold", fontSize: "42px"}}>HUGE.</span></StaffingRedText>
                <StaffingText>SWIM AGAINST THE TIDE</StaffingText>
                <StaffingParagraph>Tired of candidates that don't measure up? <br/>Our specialists identify the qualities other staffing agencies miss.</StaffingParagraph>
                </StaffingTextContent>
                <ImageGrid id="image-grid">
                    {techStaffData.map((item) => (
                        <Link to={`/${item.link}`} key={item.id} style={{textDecoration: "none"}}>
                            <StaffingCard 
                            key={item.id}
                            img={item.img}
                            title={item.title}
                            isSelected={selectedItem === item}
                            borderColor={getBorderColor(item.id)}
                            showTitle={selectedItem === item}
                            onClick={ ()=> handleItemClick(item) }
                            />
                        </Link>
                    ))}
                </ImageGrid>
                {selectedItem && (
                    <InfoContainer id="info-container">
                        <InfoWrapper titleColor={titleColor}>
                            <Icon src={getIconForItem(selectedItem.id)} />
                            <InfoH2 style={{ color: titleColor }}>{selectedItem.title}</InfoH2>
                        </InfoWrapper>
                        <InfoBold>{selectedItem.subheader}</InfoBold>
                        <InfoText>{selectedItem.text}</InfoText>
                    </InfoContainer>
                )}
            {renderSelectedItemComponent()}
            <ContactUsDiv style={{ paddingTop: '90px'}}>
                <ContactUsText>Ready to revamp your workforce? Reach out!</ContactUsText>
                <ContactUsButton onClick={toggleFormVisibility}>Contact Us</ContactUsButton>
                {isFormVisible && (
                    <div ref={formRef}>
                        <BusinessInquiriesForm />
                    </div>
                )}
            </ContactUsDiv>
        </TechStaffingContainer>
    )
}